import React, { useContext } from "react";
import { FormGroup } from "../../components/FormGroup";
import { StepSlider } from "../../components/StepSlider";
import { HexpertContext } from "../../contexts/HexPertProvider";
import { PageQuestion } from "../../types/hexpertTypes";
import {
  unitConverter,
  unitConvertName,
  UnitTypes,
} from "../../helpers/unitsConversion";
import './WeFitStepSliderBlock.scss';

type WeFitStepSliderBlockProps = PageQuestion & {
  steps?: any[]; // @todo;
  title?: string;
  unit?: string;
  unitType?: UnitTypes;
  formName?: string;
  currentStepIndex?: number;
  action?: (val: string) => void;
};

export const WeFitStepSliderBlock = ({
  Label,
  unit,
  unitType,
  Options,
  Tooltip,
  currentStepIndex,
  action,
}: WeFitStepSliderBlockProps) => {
  const { state } = useContext(HexpertContext);

  const convertUnit = (unit: string) => {
    return unit
      .split("-")
      .map((unit) =>
        Math.round(unitConverter(unitType, state.unitSystem, unit))
      )
      .join(" - ");
  };
  return (
    <FormGroup
      title={Label}
      titleUnit={unitConvertName(unitType, state.unitSystem)}
      tooltip={Tooltip}
    >
      {Options &&
        Options?.length > 0 &&
        Options[currentStepIndex === -1 ? 0 : currentStepIndex] && (
          <p className="c-hex-step-slider-block-value">
            {convertUnit(
              Options[currentStepIndex === -1 ? 0 : currentStepIndex]?.Caption
            )}{" "}
            {unitConvertName(unitType, state.unitSystem)}
          </p>
        )}

      <form
        onChange={(e) => {
          // @ts-ignore
          action(Options[e.target.value].Value);
        }}
      >
        <StepSlider
          steps={Options}
          onChange={(value) => {
            action(value);
          }}
          name={Label}
          selectedPosition={
            state?.formAnswers && currentStepIndex === -1 ? 0 : currentStepIndex
          }
          convertUnit={convertUnit}
        />
      </form>
    </FormGroup>
  );
};
